import React, {Component} from 'react';
import './INetwork.css';
import networkimg from '../../../images/network.png';

export default class INetwork extends Component {
	render() {
		return (
			<div className="i_network_container">
				<div className="i_network_title">OUR CORPORATE NETWORK</div>
				<div><img src={networkimg} /></div>
				<div className="i_network_subtitle">
					<span>PPI has an unparalleled ability to make a significant and positive impact in Asia-Pacific through its world class investment management team.</span>
				</div>
				<hr />

			</div>
		);
	}
}
